import { makeStyles } from '@material-ui/core/styles'

export const useReviewStyles = makeStyles(theme => ({
  volunteerReview: {
    width: '100%',
    maxWidth: '462px',
    margin: '0 auto',
    paddingBottom: '23px',
  },
  field: {
    marginBottom: '20px',
    '&:last-of-type': {
      marginBottom: '30px',
    },
  },
  fieldLabel: {
    display: 'block',
    marginBottom: '4px',
    fontFamily: 'Nunito, sans-serif',
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#0F5DB5',
  },
  fieldValue: {
    margin: 0,
    fontFamily: 'Nunito, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#74777F',
    wordBreak: 'break-all',
  },
  passwordRow: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '12px',
  },
  passwordValue: {
    margin: 0,
    fontFamily: 'Nunito, sans-serif',
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
    color: '#74777F',
    letterSpacing: '2px',
  },
  visibilityButton: {
    flexShrink: 0,
    marginTop: '-4px',
    padding: '4px',
    color: '#0F5DB5',
  },
  checkboxField: {
    marginBottom: '30px',
  },
}))
